import React from 'react';
import {
    Subtitle,
} from './style';
import Button from '../../Button';
import utils from '../../../../services/utils';

export default () => (
	<>
		<div className="d-flex align-items-center flex-column" style={{ paddingTop: '30px' }}>
			<Subtitle>
				Obrigado por contratar Campanha Webmotors!<br />
				Recebemos o seu pedido, e já estamos verificando.
			</Subtitle>
			<Subtitle>
				Você receberá um e-mail de confirmação
			</Subtitle>
			<Subtitle>
				Para acompanhar os resultados da sua campanha, clique na aba relatórios.
			</Subtitle>
			<Subtitle>
				Boas Vendas :)
			</Subtitle>
			<Button
				type="link"
				fontSize="14px"
				padding="11px 15px"
				to={`${utils.basePath()}/campanhas`}
				height="47px"
				margin="0 0 32px 0"
				fit
			>
				VOLTAR PARA A HOME
			</Button>
		</div>
	</>
	);
